// Dashboard Users summary page translations (en-US), loaded into dashboard.users.summary by ../en-US.users.js
module.exports = {
  menu: "Summary",
  title: "Summary",
  description: "The indicators of the former “Users” tab, now with comparison and trend.",
  kpis: {
    total: "Total",
    complete: "Complete profiles",
    incomplete: "Incomplete profiles",
    deleted: "Deleted profiles",
    active: "Active",
    newUsers: "New",
    engagement: "Average engagement / user",
    retention: "Retention",
  },
  info: {
    total: "Accounts registered on the last day of the period.\nSource: Firebase (profile index).",
    complete: "Active profiles created up to the end of the period with cover, bio, photo, birth date and gender filled in.\nSource: Firebase (profile index).",
    incomplete: "Active profiles created up to the end of the period with at least one of those fields missing.\nSource: Firebase (profile index).",
    deleted: "Accounts created in the period that are no longer active (deleted or deactivated).\nSource: Firebase (profile index).",
    active: "Unique users who used the app in the period.\nSource: Google Analytics (without it, Firebase: activity log sent by the apps).",
    newUsers: "Accounts created in the period.\nSource: Firebase (profile index).",
    engagement: "Average time using the app per active user, per day.\nSource: Google Analytics (without it, Firebase: activity log sent by the apps).",
    retention: "New users of the period who came back to the app 7 days after their first day, shown as 1 in N.\nSource: Google Analytics (without it, Firebase: activity log sent by the apps).",
  },
  hints: {
    retention: "active after 1 week",
    shorterThan7: "period shorter than 7 days",
  },
  minutes: "{value} min",
  engagementValue: "~{value} min",
  retentionValue: "1 in {n}",
  modals: {
    complete: {
      title: "Complete profiles",
      subtitle: "Users with every profile field filled in",
      bars: "By age range",
    },
    incomplete: {
      title: "Incomplete profiles",
      subtitle: "Users with at least one profile field not filled in",
      bars: "Missing field",
    },
    deleted: {
      title: "Deleted profiles",
      subtitle: "Accounts deleted by the users themselves",
      bars: "Compared with the 2 previous periods (same length)",
    },
    active: {title: "Active users", subtitle: "daily average of active users"},
    newUsers: {title: "New users"},
    engagement: {title: "Average engagement", subtitle: "minutes per active user"},
    retention: {
      title: "Retention",
      subtitle: "Out of every {n} people who start using VOXGO, only 1 is still active after 1 week.",
    },
  },
  missing: {
    cover: "Cover photo",
    bio: "Bio",
    avatar: "Avatar photo",
    birthDate: "Birth date",
    gender: "Gender",
  },
  age: {
    under18: "Up to 18",
    from18to30: "18 – 30",
    from30to50: "30 – 50",
    over50: "Over 50",
    unknown: "Not informed",
  },
  panels: {
    byAge: "By age range",
    byGender: "By gender",
    byCountry: "By country",
    others: "Others",
    map: "Map",
  },
  mapTabs: {
    active: "Active",
    voxpoints: "VoxPoints",
  },
  panelInfo: {
    map: "Active: users active in the period by city. VoxPoints: VoxPoints active on the last day of the period.\nSource: Active, Google Analytics (without it, Firebase: activity log), with the cities placed by Firebase (profile places); VoxPoints, Firebase (VoxPoints).",
    byAge: "Accounts registered on the last day of the period by age range.\nSource: Firebase (sign-up counters).",
    byGender: "Accounts registered on the last day of the period by gender.\nSource: Firebase (sign-up counters).",
    byCountry: "Accounts registered on the last day of the period by country of the address.\nSource: Firebase (sign-up counters).",
  },
};
